export default __webpack_public_path__ + "static/media/calendar-icon.cf4aeaf7.svg";